import { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

// Components
// import { isFacebookNavigator } from '../../helpers/utils';

// Actions
import * as actions from '../../actions/index';

class PageIdentify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: props.uuid // eslint-disable-line
    };
  }

  UNSAFE_componentWillMount() {
    this.props.setLoader(true);
  }

  componentDidMount() {}

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.authenticated === true) {
      this.props.history.push({
        pathname: '/revisao',
        search: this.props.params
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.uuid !== nextState.uuid;
  }

  render() {
    return null;
  }
}

PageIdentify.propTypes = {
  history: PropTypes.any,
  setLoader: PropTypes.func.isRequired,
  params: PropTypes.string
};

export default compose(connect(state => ({
  authenticated: state.UserReducer.authenticated,
  uuid: state.SessionReducer.uuid,
  params: state.MetricsReducer.params
}), {
  ...actions
}))(PageIdentify);
